import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import WaveSurfer from "wavesurfer.js";
import PlayAudio from '../Assets/images/play-audio.png'
import PauseAudio from '../Assets/images/pause-audio.png'
import ClipLoader from "react-spinners/ClipLoader";
import "../Assets/styles/newStyles/AudioPlayer.css";
import WaveformImage from '../Assets/images/Waveform.png'; 

export const AudioPlayer = ({ audio }) => {
  const containerRef = useRef();
  const waveSurferRef = useRef(null);
  const [isPlaying, toggleIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isAudioLoaded, setIsAudioLoaded] = useState(false); 

  useEffect(() => {
    const waveSurfer = WaveSurfer.create({
      container: containerRef.current,
      responsive: true,
      cursorWidth: 0,
      progressColor:'#ff7208',
      barWidth: 1,
      barGap:3,
      barHeight: 3,
      height:50,
      sampleRate:22000,
    });

    waveSurferRef.current = waveSurfer;

    waveSurfer.on("ready", () => {
      setDuration(waveSurfer.getDuration());
      setIsLoading(false);
      setIsAudioLoaded(true); 
    });

    waveSurfer.on("audioprocess", () => {
      setCurrentTime(waveSurfer.getCurrentTime());
    });

    waveSurfer.on("finish", () => {
      toggleIsPlaying(false);
    });

    return () => {
      waveSurfer.destroy();
    };
  }, []);

  // Load audio when play button is clicked
  const loadAudio = () => {
    setIsLoading(true);
    waveSurferRef.current.load(audio);
  };

  const handleSeek = (e) => {
    const seekTime = e.target.value * duration;
    if (isFinite(seekTime)) {
      setCurrentTime(seekTime);
      waveSurferRef.current.seekTo(seekTime / duration);
    }
  };

  const getBackgroundSize = () => {
    return { backgroundSize: '${((currentTime / duration) * 100) / 1}% 100%' };
  };

  const handlePlayPause = () => {
    if(isLoading)
      return
    if (!isPlaying) {
      loadAudio(); 
    }
    waveSurferRef.current.playPause();
    toggleIsPlaying(waveSurferRef.current.isPlaying());
  };

  return (
    <div style={{ marginRight: '10px' }}>
      <div ref={containerRef} style={{ display: 'block' }}>
        {/* Waveform will be displayed here */}
      </div>

      {!isAudioLoaded && !isLoading && ( 
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '5px' }}>
          <img src={WaveformImage} alt="Waveform Placeholder" style={{ maxHeight: '20px' }} />
        </div>
      )}

      {isLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20px' }}>
          <ClipLoader color='#ff7208' size={25} />
        </div>
      )}
      <div style={{ display: isLoading ? 'none' : 'block' }}></div> {/* Hide container when loading */}
      
      <div className='range-main-container'>
        <input
          type="range"
          value={duration ? currentTime / duration : 0}
          min="0"
          max="1"
          step="0.01"
          onChange={handleSeek}
          style={getBackgroundSize()}
          className='range-class'
        />
      </div>
      <div className="button-container">
        {/* Left-side Time */}
        <span style={{ marginRight: "7px" }} className="time-span">
          {isAudioLoaded ? `${Math.floor(currentTime)} sec` : "- sec"}
        </span>

        {/* Play/Pause Button */}
        <p
          onClick={handlePlayPause}
          type="button"
          style={{ padding: "0px", margin: "0px" }}
        >
          {isPlaying ? (
            <img src={PauseAudio} className="image-hovering" alt="Pause" />
          ) : (
            <img src={PlayAudio} className="image-hovering" alt="Play" />
          )}
        </p>

        {/* Right-side Time */}
        <span style={{ marginLeft: "7px" }} className="time-span">
          {isAudioLoaded ? `${Math.floor(duration)} sec` : "- sec"}
        </span>
      </div>
    </div>
  );
};

AudioPlayer.propTypes = {
  audio: PropTypes.string.isRequired,
};